import React, { Component } from 'react'
import { Button, Grid, Cell } from 'react-md'
import { connect } from 'react-redux'

import { FrameTypeSelect } from 'containers'

import { getFrameType } from 'redux/reducers'

import CommissionList from './CommissionList'

import './index.css'

class CommissionsView extends Component {
  constructor (props) {
    super(props)

    this.state = { frameType: 1 }

    this.handleFrameTypeChange = this.handleFrameTypeChange.bind(this)
  }

  handleFrameTypeChange (value) {
    this.setState({
      frameType: value
    })
  }

  render () {
    const {
      visible,
      form,
      readOnly,
      onShowReplicateMarkupsDialog,
      onShowReplicateMarkupsNoteDialog
    } = this.props
    const { frameType } = this.state
    const frameTitle = this.props.getFrameTypeById(frameType).id === 1
      ? 'Art Prints'
      : 'Framed Prints'
    return (
      <Grid>
        <Cell desktopSize={3} tabletSize={8} phoneSize={4}>
          <FrameTypeSelect
            id={`${form}-frameTypeSelect`}
            value={frameType}
            onChange={this.handleFrameTypeChange}
            label='Select Product'
            style={{ minWidth: 120, width: '100%' }}
          />

          <Button
            secondary
            raised
            onClick={() => onShowReplicateMarkupsDialog(
              this.props.getFrameTypeById(frameType)
            )}
            style={{
              width: '100%',
              marginTop: 15,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}
          >
            Apply to All
          </Button>

          <p style={{ marginTop: 8 }}>
            Click here to apply these markups to all your {frameTitle}. Some
            limitations apply, <a
              onClick={() => onShowReplicateMarkupsNoteDialog(
                this.props.getFrameTypeById(frameType)
              )}
              style={{ cursor: 'pointer' }}
            >
              find out more
            </a>.
          </p>
        </Cell>

        <Cell desktopSize={9} tabletSize={8} phoneSize={4}>
          <CommissionList
            frameType={frameType}
            form={form}
            readOnly={readOnly}
            visible={visible}
          />
        </Cell>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => ({
  getFrameTypeById: id => getFrameType(state, id)
})

export default connect(mapStateToProps)(CommissionsView)



// WEBPACK FOOTER //
// ./src/containers/ArtworkView/CommissionsView/index.js